import { padStart } from "lodash";
import { saveClickData } from "@/api/combo";
import Cookies from "js-cookie";

/**
 * 补足数字位数
 * @param digit 数字
 * @param len 位数
 */
export const fillDigit = (digit: number, len: number) => {
  return padStart("" + digit, len, "0");
};

/**
 * 判断设备
 */
export const isPC = () => {
  return true;
  // !navigator.userAgent.match(/(iPhone|iPod|iPad|Android|Mobile|BlackBerry|Symbian|Windows Phone)/i)
};

/**
 * 记录点击
 * @param type 类型number
 * @param data 数据
 * @param operationId 随机数
 * @param operInputParam 携参
 */
export const sendClickData = (
  type: any,
  data: any,
  operationId: any,
  operInputParam: any
) => {
  try {
    saveClickData({
      type: type,
      data: data,
      operationId: operationId,
      operInputParam: operInputParam,
      deviceInformation: Cookies.get("deviceInfor"),
    })
      .then((res: any) => {})
      .catch((error: any) => {
        console.log("error", error);
      });
  } catch (error) {}
};

/**
 * 获取路径参数
 * @param name  参数名
 * @param url  window.location.search
 */
export const getQueryString = (name: string, url: string) => {
  try {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = url.substr(1).match(reg);
    if (r != null) {
      // return unescape(r[2]);
      return decodeURI(r[2]).replace(/["']/g, "");
    }
    return null;
  } catch (error) {}
};

export const getPptIdByUrl = () => {
  const urlSearch = window.location.search;
  let recordId = getQueryString("recordId", urlSearch);
  const urlFlowId = getQueryString("flowId", urlSearch);
  const paramId = urlFlowId ? urlFlowId : recordId;
  return paramId;
};
